import React from 'react'
import { t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteJobTemplateModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <DeleteResourceModal
    alert={t`You are deleting a Job template.`}
    message={t`Are you sure you want to delete?`}
    title={t`Delete Job template`}
    {...{ onCancel, onClose, onConfirm, isOpen }}
  />
)
